import React from 'react';

export default function Landing() {
  return (
    <div className="landing">
      <div className="version-tag">v1.0.0</div>
      <h1>celest</h1>
      <p className="subtitle">
        a modern systems language — byte-granular control, explicit ownership,
        705 verified operations, dual-platform.
      </p>
      <div style={{display:'flex', gap:12, justifyContent:'center'}}>
        <a href="/dl/v1.0.0/celestc-windows-x64.exe" className="btn-download" download>
          ⬇ windows x64
        </a>
        <a href="/dl/v1.0.0/celestc-linux-x64" className="btn-download" download>
          ⬇ linux x64
        </a>
      </div>
    </div>
  );
}